import AppleSigninButton from '@components/applesignin/AppleSigninButton';
import Button from '@ui/button/Button';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SocialButton from './SocialButton';
import LineSigninButton from '@components/account/linesignin/LineSigninButton';
const OtherLoginMethods = (props) => {
    const { t } = useTranslation();
    const filteredMethods = useMemo(() => {
        return props.loginMethods.filter((e, i) => {
            if (props.loginStep == 'social-login') {
                return i != 0;
            }
            else {
                return e.ID != 'email';
            }
        });
    }, [props.loginMethods, props.loginStep]);
    return props.loginStep == 'social-login' && filteredMethods.length == 0 ? (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "text-center" }, t('label.signinwithemail')),
        React.createElement("div", { className: "other-login-methods" },
            React.createElement(Button, { type: "button", onClick: () => props.setLoginStep('register'), cls: ['button--primary'] }, t('login.registerwithpassword'))))) : (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "text-center" }, t('label.signinwithother')),
        React.createElement("div", { className: "other-login-methods" }, filteredMethods.map((login, index) => {
            return (React.createElement("div", { key: index },
                login.ID == 'Google' && React.createElement(SocialButton, { social: "google", secondary: true, reloadUrl: location.href }),
                login.ID == 'Facebook' && React.createElement(SocialButton, { social: "facebook", secondary: true, reloadUrl: location.href }),
                login.ID == 'Apple' && React.createElement(AppleSigninButton, { secondary: true }),
                login.ID == 'Line' && React.createElement(LineSigninButton, { secondary: true, reloadUrl: location.href }),
                login.ID == 'email' && (React.createElement(Button, { type: "button", onClick: () => props.setLoginStep('password'), cls: ['button--primary'] }, t('login.logintomymoncler')))));
        }))));
};
export default OtherLoginMethods;
